import { ApolloCache } from '@apollo/client';
import { ActiveListingsQuery } from '../../graphql/queries';

const deleteCachedFieldsOnActiveListingsQuery = (cache: ApolloCache<any>): void => {
  const userQueryRes = cache.readQuery<any>({
    query: ActiveListingsQuery,
  });
  cache.evict({ id: cache.identify(userQueryRes?.currentUserQuery) });
  cache.gc();
};

export default deleteCachedFieldsOnActiveListingsQuery;
